import React, { useState } from 'react';
import { Button, Col, Divider, Row, Select, Typography } from 'antd';
import { ICodigoItem, IGrupos } from '../../../../interface';

const { Text } = Typography;

interface IItemSIProps {
    item: ICodigoItem;
    sistema: string;
    grupos: IGrupos[];
    loadingGrupos: boolean;
    selectedGrupoId: string | null;
    onSelectGrupo: (sistema: string, codigo: string, grupoId: string | null) => void;
    abrirModalGrupo: (type: any, data?: any) => void;
    theme: string;
}

export const ItemSI: React.FC<IItemSIProps> = ({
    item,
    sistema,
    grupos,
    loadingGrupos,
    selectedGrupoId,
    onSelectGrupo,
    abrirModalGrupo,
    theme,
}) => {
    const [expanded, setExpanded] = useState(false);

    const descricoes = item.descricoes || (item.descricao ? [item.descricao] : []);
    const initialCount = 3;
    const hasMore = descricoes.length > initialCount;
    const visibleDescricoes = expanded ? descricoes : descricoes.slice(0, initialCount);
    const hiddenCount = descricoes.length - initialCount;

    const isLight = theme === 'light';

    return (
        <div
            style={{
                backgroundColor: isLight ? '#ffffff' : '#1f1f1f',
                border: !selectedGrupoId ? '1px solid #e62b345d' : isLight ? '1px solid #e5e7eb' : '1px solid #303030',
                borderRadius: 10,
                padding: '16px 20px',
                marginBottom: 16,
                boxShadow: isLight ? '0 1px 2px 0 rgba(0, 0, 0, 0.05)' : 'none',
            }}
        >
            <Row align="middle" justify="space-between" gutter={[16, 16]}>
                <Col xs={24} sm={14} md={15}>
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                        <Text
                            style={{
                                fontSize: 16,
                                fontWeight: 700,
                                color: isLight ? '#111827' : '#ffffff',
                            }}
                        >
                            {item.codigo}
                        </Text>
                        <Text
                            type="secondary"
                            style={{
                                fontSize: 14,
                                color: isLight ? '#6b7280' : '#a3a3a3',
                            }}
                        >
                            {item.tipo_descricao || item.descricao}
                        </Text>
                    </div>
                </Col>
                <Col xs={24} sm={10} md={9} style={{ textAlign: 'right' }}>
                    <Select
                        showSearch
                        allowClear
                        placeholder="Selecione um grupo..."
                        loading={loadingGrupos}
                        disabled={loadingGrupos}
                        value={selectedGrupoId || undefined}
                        onChange={(val) => onSelectGrupo(sistema, item.codigo, val || null)}
                        style={{ width: '100%', maxWidth: 280 }}
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        dropdownRender={(menu) => (
                            <div>
                                <div style={{ padding: 8 }}>
                                    <Button
                                        type="dashed"
                                        block
                                        onClick={() => abrirModalGrupo('grupo')}
                                    >
                                        Novo grupo +
                                    </Button>
                                </div>
                                <Divider style={{ margin: '4px 0' }} />
                                {menu}
                            </div>
                        )}
                        options={grupos.map((g) => ({ label: g.tipo === null ? g.nome : `${g.tipo} - ${g.nome}`, value: g.id, }))}
                    />
                </Col>
            </Row>
            {descricoes.length > 0 && (
                <>
                    <div
                        style={{
                            borderTop: !selectedGrupoId ? '1px dashed #e62b345d' : isLight ? '1px dashed #e5e7eb' : '1px dashed #303030',
                            marginTop: 14,
                            marginBottom: 12,
                        }}
                    />
                    <div>
                        <Text
                            style={{
                                fontSize: 11,
                                fontWeight: 700,
                                letterSpacing: '0.05em',
                                color: isLight ? '#9ca3af' : '#6b7280',
                                textTransform: 'uppercase',
                                display: 'block',
                                marginBottom: 8,
                            }}
                        >
                            DESCRIÇÕES ({descricoes.length})
                        </Text>

                        <div
                            style={{
                                maxHeight: '150px',
                                overflowY: 'auto',
                                margin: 0,
                                paddingLeft: 18,
                                listStyleType: 'disc',
                            }}
                        >
                            {visibleDescricoes.map((desc, idx) => (
                                <li key={idx} style={{ marginBottom: 4 }}>
                                    <Text
                                        style={{
                                            fontSize: 13,
                                            color: isLight ? '#4b5563' : '#d1d5db',
                                        }}
                                    >
                                        {desc}
                                    </Text>
                                </li>
                            ))}
                        </div>

                        {hasMore && (
                            <div style={{ marginTop: 6, paddingLeft: 18 }}>
                                <Button
                                    type="link"
                                    onClick={() => setExpanded(!expanded)}
                                    style={{
                                        padding: 0,
                                        height: 'auto',
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: '#2563eb',
                                    }}
                                >
                                    {expanded ? 'Ver menos' : `Ver mais ${hiddenCount} descrições`}
                                </Button>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};